(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["configurator-design-notes"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('configurator-character-count')) {
    customElements.define('configurator-character-count', class extends HTMLElement {
      connectedCallback() {
        this.input = this.querySelector('[data-character-input]');
        this.output = this.querySelector('[data-character-count]');

        if (!this.input || !this.output) return;

        this.update = () => {
          this.output.textContent = `${this.input.value.length} / ${this.input.maxLength}`;
        };

        this.input.addEventListener('input', this.update);
        this.update();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
